<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__accessmanagementlog}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item label="">
          <wPickers v-model="dateValue" @input="getTimes"></wPickers>
        </el-form-item>
        <el-form-item label="">
          <wCity v-model="dataForm.city"  defaultUrl="/sys/dayplan/accessToAccess"></wCity>
        </el-form-item>
       
        <el-form-item>
          <renSelect
            v-model="dataForm.product"
            dictType="loan_type"
            originPage="put"
            placeholder="产品"
          ></renSelect>
        </el-form-item>

        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
              <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
            </el-form-item>
            <el-form-item>
              <el-button v-if="$hasPermission('sys:accessmanagementlog:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
            </el-form-item>
            <el-form-item>
              <el-button v-if="$hasPermission('sys:accessmanagementlog:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
            </el-form-item> -->
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
        @sort-change="dataListSortChangeHandle($event,false)"
      >
        <el-table-column
          prop="productName"
          label="产品"
          header-align="center"
          align="center"
          
        ></el-table-column>
        <el-table-column
          prop="city"
          label="城市"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>

        <el-table-column
          prop="datas"
          label="投放日期"
          header-align="center"
          align="center"
          sortable="custom"
        >
        <template slot-scope="scope">
          <div>
            {{scope.row.datas.split(' ')[0]}}
          </div>
        </template>
      </el-table-column>

        <el-table-column
          prop="timePeriod"
          label="投放时间段"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>

        <el-table-column
          prop="lockNumber"
          label="锁定线索数量（个）"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
    </div>
  </el-card>
</template>
    
    <script>
import mixinViewModule from "@/mixins/view-module";

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/dayplan/page",
        getDataListIsPage: true,
        exportURL: "/sys/dayplan/export",
        deleteURL: "/sys/dayplan",
        deleteIsBatch: true,
      },
      dateValue: "",
   
      dataForm: {
        id: "",
        product: "",
        startDate: "",
        endDate: "",
        city: '',
      },
    };
  },
  mounted() {
   
    this.dateValue =  this.getTime()

    this.getTimes()
    this.getDataList()
  },
  methods: {
    getTime() {
      let now = new Date();
      let year = now.getFullYear(); // 获取四位数的年份，例如 2023
      let month = now.getMonth() + 1; // 获取当前月份，范围为 0-11，需要加上 1
      let date = now.getDate(); // 获取当前日期
      let hours = now.getHours(); // 获取当前小时数，范围为 0-23
      let minutes = now.getMinutes(); // 获取当前分钟数，范围为 0-59
      let seconds = now.getSeconds(); // 获取当前秒数，范围为 0-59
      month = month < 10 ? "0" + month : month;
      date = date < 10 ? "0" + date : date;
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      // // console.log(year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds);
    
      let currentDate = new Date();

      // 加一天
      currentDate.setDate(currentDate.getDate() + 1);
      let h = currentDate.getFullYear();
      let m =
        (currentDate.getMonth() + 1 < 10 ? "0" : "") +
        (currentDate.getMonth() + 1);
      let day = (currentDate.getDate() < 10 ? "0" : "") + currentDate.getDate();
      // 输出日期

 
      let res = year + "-" + month + "-" + date;
      let res1 = h + "-" + m + "-" + day 
    
      return [res,res1]
      // return  year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds
    },
    getTimes() {
      console.log(this.dateValue);
      this.getTime();
      if (this.dateValue != null) {
        this.dataForm.startDate = this.dateValue[0];
        this.dataForm.endDate = this.dateValue[1];
      } else {
        this.dataForm.startDate = "";
        this.dataForm.endDate = "";
      }
    },

  },
  components: {},
};
</script>
    
    